const getDuration = (file) => {
    return new Promise((resolve, reject) => {
        try {
            const url = URL.createObjectURL(file);
            const video = document.createElement('video');

            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(url);
                resolve(video.duration);
            };

            video.onerror = () => {
                resolve(0);
            };

            video.src = url;
        } catch (error) {
            // console.log(`Erro para obter duração do arquivo ${file}`);
            resolve(0);
        }
    });
};

const getMetadata = async (file) => {
    try {
        const duration = await getDuration(file);
        const size = file.size;

        return {
            duration,
            size,
        };
    } catch (error) {
        console.error("Erro ao obter metadados: ", error);
    }
};
export default getMetadata;